module.exports = __webpack_public_path__ + "img/background960w.97dd087c.png";